import { RootState } from '../store'

export const getInventoryViewerModalState = (state: RootState): boolean => state.inventoryViewerModal.isOpen
